import { render, staticRenderFns } from "./AttrList.vue?vue&type=template&id=ea43f672&scoped=true&"
import script from "./AttrList.vue?vue&type=script&lang=js&"
export * from "./AttrList.vue?vue&type=script&lang=js&"
import style0 from "./AttrList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AttrList.vue?vue&type=style&index=1&id=ea43f672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea43f672",
  null
  
)

export default component.exports